<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="parametersG20Jds">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="PC号">
            <el-input v-model.trim="filter.contractCode" clearable/>
          </vm-search>
          <vm-search label="工号">
            <el-input v-model.trim="filter.workerNo" clearable/>
          </vm-search>
          <vm-search label="创建时间">
            <div class="block">
              <el-date-picker
                  v-model="filter.startTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  style="width: 165px"
                  placeholder="选择开始时间"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endTime"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 165px"
                  placeholder="选择结束时间"/>
            </div>
          </vm-search>
          <vm-search label="柜体条码">
            <el-input v-model.trim="filter.cabinetCode" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column
          fixed
          width="100"
          prop="contractCode"
          align="center"
          label="PC号"/>
      <el-table-column
          fixed
          width="100"
          prop="workerNo"
          align="center"
          label="工号"/>
      <el-table-column fixed prop="tester" align="center" label="测试员"/>
      <el-table-column
          fixed
          width="100"
          prop="cabinetCode"
          align="center"
          label="柜体条码"/>
      <el-table-column
          fixed
          width="170"
          prop="insertedAt"
          align="center"
          label="测试日期"/>
      <el-table-column prop="testResult" align="center" label="测试结果"/>
      <el-table-column prop="getSetupWay" align="center" label="配置获取方式"/>
      <el-table-column prop="options" align="center" label="类型"/>
      <el-table-column prop="shouldItems" align="center" label="应该测试项目数"/>
      <el-table-column prop="actualItems" align="center" label="实际测试项目数"/>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import KeyComponentEdit from "@/views/information/KeyComponent/KeyComponentEdit";
  export default {
    name: "",
    components: {VmTable,VmSearch},
    data() {
      return {
        idList: "",
        filter: {
          cabinetCode: "",
          contractCode: "",
          startTime: "",
          endTime: "",
          workerNo: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
    },
  };
</script>

<style scoped>

</style>
